<template>
  <div class="search__container">
    <p class="search__title"></p>
    <input
      v-model="text"
      class="search__input"
      type="text"
      placeholder="Szukaj..."
    />
  </div>
</template>

<script>
export default {
  props: ["initialValue"],
  emits: ["handleSearch"],
  mounted() {},
  watch: {
    text(content) {
      this.handleSearchInput(content);
    },
  },
  methods: {
    handleSearchInput(content) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.$emit("handleSearch", content);
      }, 600);
    },
  },
  data() {
    return {
      text: "",
      timeoutId: "",
    };
  },
};
</script>

<style scoped>
.search__container {
  margin-bottom: 3rem;
}
input {
  background-color: white;
  margin-bottom: 30px;
  padding: 10px 15px;
  border-radius: 16px;
  color: #6d6963;
  min-width:320px;
}
@media (max-width: 700px) {
  .search__input {
    min-width: 0px;
    font-size: 12px;
  }
}

@media screen and (max-width: 400px) {
  .search__input {
    min-width: 280px;
    font-size: 10px;
  }
}
</style>
